// @ts-nocheck
import { writable } from 'svelte/store';
import { browser } from "$app/environment";
import { locale } from 'svelte-i18n';
// import base_map_1 from '$lib/images/basemap-citra-satelit.jpg';
// import base_map_2 from '$lib/images/basemap-peta-dasar.jpg';

import indonesiaLogo from '$lib/images/icons/Flag_Indonesia.png';
import UkLogo from '$lib/images/icons/Flag_United_Kingdom.png';

let setLang = writable({
    'default' : browser ? (localStorage.getItem('lang') != null ? localStorage.getItem('lang') : 'id') : 'id',
    'id' : {
        'text' : 'ID',
        'img'  : indonesiaLogo
    },
    'en' : {
        'text' : 'EN',
        'img'  : UkLogo
    }
});

export {setLang}